// extracted by mini-css-extract-plugin
export default {"fontFamily":"\"Cairo\",sans-serif"};